<template>
	<div class="c-toast-item" @click="remove">
		<div class="c-toast-item__window">
			<div class="c-toast-item__progress" ref="progress"></div>
			<p class="c-toast-item__title" v-if="title" v-html="title"></p>
			<article v-if="content" v-html="content"></article>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			timer: null,
		};
	},

	props: {
		toastObject: {
			type: Object,
			default: {},
		},
	},

	computed: {
		content: function () {
			if (this.toastObject.content) {
				return this.toastObject.content;
			}
			return false;
		},
		title: function () {
			if (this.toastObject.title) {
				return this.toastObject.title;
			}
		},
	},

	methods: {
		startTimer: function () {
			this.timer = setTimeout(() => {
				this.stopTimer();
			}, 6000);
		},
		stopTimer: function () {
			this.timer = null;
			this.remove();
		},
		remove: function () {
			if (this.lock) {
				return;
			}
			this.$emit('remove', this.toastObject.id);
		},
	},

	mounted: function () {
		this.startTimer();
	},
};
</script>

<style lang="scss">
.c-toast-item {
	position: relative;
	display: inline-block;
	margin-top: var(--spacer-sm);
	border-radius: var(--border-radius-lg);
	background-color: var(--g1);
	pointer-events: all;
	overflow: hidden;
	box-shadow: 0 1.1px 1.6px rgba(0, 0, 0, 0.101),
		0 3.6px 5.4px rgba(0, 0, 0, 0.149), 0 16px 24px rgba(0, 0, 0, 0.25);

	transition: all 250ms cubic-bezier(0.3, 0.76, 0.57, 1.025);

	&__window {
		padding: var(--margin-lg) var(--spacer-sm);
		width: 100%;
		height: 100%;
		position: relative;
		text-align: center;

		article {
			font-size: var(--font-size-sm);
			opacity: 0.85;
		}
	}

	&__title {
		margin-bottom: var(--margin-sm);
		font-weight: 600;
		letter-spacing: 0.3px;
	}

	&__progress {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		transform: scaleX(0);
		background-color: rgba(127, 127, 127, 0.1);
	}
}
</style>